import React from "react";
import ModalEditResource from "../ModalEditResource";
import { fetchAddressByZipCode } from "../../helpers/address";
import states from "../../seeds/states";

const fields = [
    {
        title: 'Dados cadastrais',
        fields: [
            { name: 'cnpj', label: 'CNPJ', col: 4, mask: 'convertToCnpj' },
            { name: 'company_name', label: 'Razão social', col: 8 },
            { name: 'trade_name', label: 'Nome da empresa', col: 4 },
            { name: 'ie', label: 'IE', col: 4 },
            {
                name: 'im',
                label: 'IM',
                col: 4,
                hint: 'Inscrição municipal — exigida só para emitir nota de serviço.',
            },
        ],
    },
    {
        title: 'Endereço',
        fields: [
            { name: 'zip_code', label: 'CEP', col: 3, mask: 'convertToCep', autofill: fetchAddressByZipCode },
            { name: 'street', label: 'Logradouro', col: 6 },
            { name: 'number', label: 'Número', col: 3 },
            { name: 'complement', label: 'Complemento', col: 3 },
            { name: 'district', label: 'Bairro', col: 3 },
            { name: 'city', label: 'Cidade', col: 3 },
            { name: 'state', label: 'Estado', col: 3, type: 'select', options: states },
        ],
    },
];

/**
 * Cadastro da empresa sem sair da tela (BDM-887).
 *
 * Dois campos vão no `keep`, e nenhum dos dois é opcional:
 *
 * - `type` são os marcadores da empresa (faturamento, cliente, fornecedor). A
 *   API exige o campo, e quem abre este modal está corrigindo dados fiscais —
 *   não escolhendo o que a empresa é.
 * - `admin_id` porque o update da empresa propaga o responsável para os
 *   orçamentos e clientes dela. Sem reenviar o valor atual, o PUT chegaria
 *   sem a chave e o responsável seria apagado de tudo que está pendurado na
 *   empresa.
 */
export const ModalEditCompany = ({ show, close, companyId, highlight, intro, level, onSaved }) => (
    <ModalEditResource
        show={show}
        close={close}
        title={`Dados da empresa`}
        endpoint={companyId ? `/company/${companyId}` : null}
        fields={fields}
        keep={['type', 'admin_id']}
        size={`big`}
        level={level}
        intro={intro}
        highlight={highlight}
        onSaved={onSaved}
    />
);

export default ModalEditCompany;
